export function polarToCartesianCoordinates(center: number[], radius: number, angle: number) {
  return [center[0] + radius * Math.cos(angle), center[1] + radius * Math.sin(angle)]
}
